import { getMainApiBaseUrl } from '@/config/apiEnv';

export function getGoogleSignInUrl(): string {
  const base = getMainApiBaseUrl();
  if (base.startsWith('http://') || base.startsWith('https://')) {
    return `${base.replace(/\/$/, '')}/auth/google`;
  }
  return '/api/v1/auth/google';
}

export async function isGoogleAuthEnabled(): Promise<boolean> {
  try {
    const base = getMainApiBaseUrl().replace(/\/$/, '');
    const res = await fetch(`${base}/auth/google/status`);
    if (!res.ok) return false;
    const data = (await res.json()) as { enabled?: boolean };
    return data.enabled === true;
  } catch {
    return false;
  }
}
